export default __webpack_public_path__ + "static/media/P203 zu P201.ee89792f.mp3";